import React from 'react';
import { styled } from 'baseui';
import Loader from '../loader';
const LoaderMsgDiv = styled('div', {
  width: '100%',
  height: '100%',
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  zIndex: 3,
  top: 0
});
type PropsT = {
  hideLabel?: boolean;
  loadingMessage?: string;
  size?: string;
  isModernizedPlayer?: boolean;
};
const MediaLoader = ({
  hideLabel,
  loadingMessage,
  size
}: PropsT) => {
  return <LoaderMsgDiv data-testid="loaderDiv">
      <Loader hideLabel={hideLabel} loadingMessage={loadingMessage} size={size} />
    </LoaderMsgDiv>;
};
export default MediaLoader;